var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1289_5088)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    stroke: "#D1D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5863 11.8574L18.1423 9.41399C17.9372 9.20894 17.6591 9.09375 17.3691 9.09375C17.079 9.09375 16.8009 9.20894 16.5958 9.41399L9.85172 16.1575C9.74981 16.2588 9.66901 16.3793 9.614 16.512C9.55899 16.6448 9.53086 16.7871 9.53125 16.9308V19.3748C9.53125 19.6648 9.64649 19.943 9.85161 20.1482C10.0567 20.3533 10.3349 20.4685 10.625 20.4685H19.8125C19.9866 20.4685 20.1535 20.3994 20.2765 20.2763C20.3996 20.1532 20.4688 19.9863 20.4688 19.8123C20.4688 19.6382 20.3996 19.4713 20.2765 19.3482C20.1535 19.2252 19.9866 19.156 19.8125 19.156H14.8359L20.5863 13.4045C20.6879 13.303 20.7685 13.1824 20.8235 13.0496C20.8785 12.9169 20.9068 12.7746 20.9068 12.631C20.9068 12.4873 20.8785 12.345 20.8235 12.2123C20.7685 12.0796 20.6879 11.959 20.5863 11.8574ZM12.9766 19.156H10.8438V17.0232L15.4375 12.4295L17.5703 14.5623L12.9766 19.156ZM18.5 13.6326L16.3672 11.4998L17.3702 10.4968L19.503 12.6296L18.5 13.6326Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1289_5088",
    x: 0,
    y: 0,
    width: 30,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1289_5088"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1289_5088",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d3794c21.svg";
export { ForwardRef as ReactComponent };